import { render, staticRenderFns } from "./situacaoFrota.vue?vue&type=template&id=7408e1bd"
import script from "./situacaoFrota.vue?vue&type=script&lang=js"
export * from "./situacaoFrota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports